/**
 * Palette d'attribution automatique des couleurs de trace.
 *
 * Reprend `MainActivity.kt:74-77` : huit teintes Material 600.
 * L'ordre est significatif — c'est l'ordre d'attribution.
 */

export const TRACK_COLORS = [
  '#E53935', // rouge
  '#1E88E5', // bleu
  '#43A047', // vert
  '#FB8C00', // orange
  '#8E24AA', // violet
  '#00ACC1', // cyan
  '#D81B60', // rose
  '#00897B', // teal
] as const

export type TrackColor = (typeof TRACK_COLORS)[number]

/**
 * Choisit la couleur d'une nouvelle trace.
 *
 * Même règle que l'application Android (`MainActivity.kt:67-71`) : on prend
 * la première couleur de la palette qui n'est pas déjà utilisée ; si les huit
 * sont prises, on retombe sur un simple modulo — deux traces peuvent alors
 * partager une couleur, ce qui est assumé.
 */
export function pickTrackColor(usedColors: readonly string[]): string {
  const used = new Set(usedColors.map((c) => c.toUpperCase()))

  for (const color of TRACK_COLORS) {
    if (!used.has(color)) {
      return color
    }
  }

  return TRACK_COLORS[usedColors.length % TRACK_COLORS.length]!
}
